import { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiURL } from '../lib/axios';

interface HealthStatus {
  status: 'ok' | 'error';
  service?: string;
  version?: string;
  timestamp?: string;
  database?: string;
  redis?: string;
  error?: string;
}

export function HealthCheck() {
  const [health, setHealth] = useState<HealthStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const response = await axios.get(`${getApiURL()}/health`, { timeout: 5000 });
        setHealth(response.data);
      } catch (error) {
        setHealth({
          status: 'error',
          error: error instanceof Error ? error.message : 'Unknown error'
        });
      } finally {
        setLoading(false);
      }
    };

    checkHealth();
    const interval = setInterval(checkHealth, 10000); // Check every 10s
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div className="p-4 bg-yellow-50 border border-yellow-200 rounded">
        <p className="text-yellow-800">🔄 Conectando con el backend...</p>
      </div>
    );
  }

  if (!health || health.status === 'error') {
    return (
      <div className="p-4 bg-red-50 border border-red-200 rounded">
        <h3 className="font-bold text-red-800 mb-2">❌ Error de conexión</h3>
        <p className="text-red-700 text-sm">{health?.error || 'No se pudo conectar con el backend'}</p>
      </div>
    );
  }

  return (
    <div className="p-4 bg-green-50 border border-green-200 rounded">
      <h3 className="font-bold text-green-800 mb-2">✅ Backend conectado</h3>
      <div className="text-sm text-green-700 space-y-1">
        <p><strong>Servicio:</strong> {health.service}</p>
        <p><strong>Versión:</strong> {health.version}</p>
        <p><strong>Base de datos:</strong> {health.database}</p>
        <p><strong>Redis:</strong> {health.redis}</p>
        <p className="text-xs text-green-600 mt-2">Última actualización: {new Date(health.timestamp || '').toLocaleString()}</p>
      </div>
    </div>
  );
}
